module.exports = __webpack_public_path__ + "static/google-new-logo-2015-640x344-16be3530896f2639c609d11b544620fc.png";